<ngx-spinner bdOpacity=0.9
             bdColor="rgba(51,51,51,0.39)"
             size="large"
             color="#fff"
             type="ball-atom"
             [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<app-custom-loading-spinner 
  [backdrop]="true" 
  [fullScreen]="true">
</app-custom-loading-spinner>

<router-outlet></router-outlet>